<div class="ai-section">
  <label class="ngsild-form__label">Additional Information</label>

  <div class="ai-mode" role="radiogroup" aria-label="Additional information type">
    <button
      type="button"
      class="ai-mode__btn"
      [class.ai-mode__btn--selected]="mode === 'faq'"
      (click)="selectMode('faq')"
    >
      <span class="ai-mode__radio" [class.ai-mode__radio--on]="mode === 'faq'" aria-hidden="true"></span>
      Add FAQ's
    </button>
    <button
      type="button"
      class="ai-mode__btn"
      [class.ai-mode__btn--selected]="mode === 'info'"
      (click)="selectMode('info')"
    >
      <span class="ai-mode__radio" [class.ai-mode__radio--on]="mode === 'info'" aria-hidden="true"></span>
      Add Information
    </button>
  </div>

  @if (pendingMode) {
    <div class="ai-replace" role="alert">
      <p class="ai-replace__text">{{ replaceMessage(pendingMode) }}</p>
      <div class="ai-replace__actions">
        <button type="button" class="ai-replace__cancel" (click)="cancelPendingMode()">Cancel</button>
        <button type="button" class="ai-replace__confirm" (click)="confirmPendingMode()">
          Remove and continue
        </button>
      </div>
    </div>
  }

  @if (mode === 'faq') {
    <div class="ai-faq">
      @for (row of faqRows; track $index; let i = $index) {
        <div class="ai-faq__row">
          <div class="ai-faq__row-head">
            <label class="ngsild-form__label" [attr.for]="'ai-faq-q-' + i">Question</label>
            <button
              type="button"
              class="ai-faq__remove"
              aria-label="Remove question"
              (click)="removeFaqRow(i)"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          <input
            [id]="'ai-faq-q-' + i"
            type="text"
            class="ngsild-form__input ngsild-form__input--single-line"
            [class.ngsild-form__input--error]="showQuestionError(i)"
            placeholder="Please enter question"
            [ngModel]="row.question"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onFaqQuestionChange(i, $event)"
          />

          <label class="ngsild-form__label" [attr.for]="'ai-faq-a-' + i">Answer</label>
          <div class="ngsild-form__textarea-shell">
            <textarea
              [id]="'ai-faq-a-' + i"
              class="ngsild-form__textarea ngsild-form__textarea--compact ngsild-form__textarea--with-count"
              [class.ngsild-form__input--error]="showAnswerError(i)"
              rows="3"
              [maxlength]="faqAnswerMax"
              placeholder="Enter your answer..."
              [ngModel]="row.answer"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onFaqAnswerChange(i, $event)"
            ></textarea>
            <span
              class="ngsild-form__textarea-count"
              [class.ngsild-form__textarea-count--warn]="row.answer.length > 0 && row.answer.length < faqAnswerMin"
              [class.ngsild-form__textarea-count--limit]="row.answer.length >= faqAnswerMax"
              aria-hidden="true"
            >{{ row.answer.length }} ({{ faqAnswerMin }}-{{ faqAnswerMax }})</span>
          </div>

          @if (faqRowMessage(i); as message) {
            <p class="ngsild-form__error">{{ message }}</p>
          }
        </div>
      }

      <div class="ai-faq__add">
        <button
          type="button"
          class="ngsild-btn-add-descriptor"
          [disabled]="!canAddMoreFaq"
          (click)="addFaqRow()"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Add More
        </button>
      </div>
    </div>
  }

  @if (mode === 'info') {
    <div class="ai-info">
      <div class="ai-faq__row-head">
        <label class="ngsild-form__label" for="ai-info-text">Provide Information</label>
        <button type="button" class="ai-faq__remove" aria-label="Remove information" (click)="closeInfo()">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <div class="ngsild-form__textarea-shell">
        <textarea
          id="ai-info-text"
          class="ngsild-form__textarea ngsild-form__textarea--tall ngsild-form__textarea--with-count"
          rows="5"
          [maxlength]="infoMax"
          placeholder="Brief summary (max 1000 characters)"
          [ngModel]="infoText"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onInfoTextChange($event)"
        ></textarea>
        <span
          class="ngsild-form__textarea-count"
          [class.ngsild-form__textarea-count--warn]="infoText.length > infoMax * 0.9"
          [class.ngsild-form__textarea-count--limit]="infoText.length >= infoMax"
          aria-hidden="true"
        >{{ infoText.length }}/{{ infoMax }}</span>
      </div>
    </div>
  }
</div>
